import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useStaff } from "@/context/StaffContext";
import { apiError } from "@/lib/api";
import { MONOGRAM } from "@/data/site";

export function StaffLogin() {
  const { login } = useStaff();
  const navigate = useNavigate();
  const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await login(email, password); navigate("/staff/dashboard"); }
    catch (e) { setErr(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <Shell title="Operations" subtitle="Staff Access">
      <form onSubmit={submit} data-testid="staff-login-form">
        <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} testid="staff-login-email" />
        <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} testid="staff-login-password" />
        {err && <p className="mb-4 text-sm text-red-400" data-testid="staff-login-error">{err}</p>}
        <button disabled={loading} data-testid="staff-login-submit" className="w-full bg-gold py-4 text-xs font-bold uppercase tracking-widest text-black hover:bg-gold-bright disabled:opacity-50">{loading ? "Authenticating…" : "Enter Dashboard"}</button>
      </form>
      <Link to="/staff/register" className="mt-6 block text-center text-xs uppercase tracking-widest text-cream/50 hover:text-gold">Register with invite code</Link>
    </Shell>
  );
}

export function StaffRegister() {
  const { register } = useStaff();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", invite_code: "" });
  const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await register(form.name, form.email, form.password, form.invite_code); navigate("/staff/dashboard"); }
    catch (e) { setErr(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <Shell title="Register" subtitle="New Staff Account">
      <form onSubmit={submit} data-testid="staff-register-form">
        <Input label="Full name" value={form.name} onChange={set("name")} testid="staff-register-name" />
        <Input label="Email" type="email" value={form.email} onChange={set("email")} testid="staff-register-email" />
        <Input label="Password" type="password" value={form.password} onChange={set("password")} testid="staff-register-password" />
        <Input label="Invite code" value={form.invite_code} onChange={set("invite_code")} testid="staff-register-invite" />
        {err && <p className="mb-4 text-sm text-red-400" data-testid="staff-register-error">{err}</p>}
        <button disabled={loading} data-testid="staff-register-submit" className="w-full bg-gold py-4 text-xs font-bold uppercase tracking-widest text-black hover:bg-gold-bright disabled:opacity-50">{loading ? "Creating…" : "Create Account"}</button>
      </form>
      <Link to="/staff/login" className="mt-6 block text-center text-xs uppercase tracking-widest text-cream/50 hover:text-gold">Back to sign in</Link>
    </Shell>
  );
}

function Shell({ title, subtitle, children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-4">
      <div className="w-full max-w-sm border border-gold/25 bg-ink p-8">
        <div className="mb-8 text-center">
          <img src={MONOGRAM} alt="HYEAMAN" className="mx-auto h-14 w-auto" />
          <p className="overline-label mt-4">{subtitle}</p>
          <h1 className="font-black uppercase tracking-tight text-cream text-3xl">{title}</h1>
        </div>
        {children}
      </div>
    </div>
  );
}
function Input({ label, type = "text", value, onChange, testid }) {
  return (
    <label className="mb-4 block">
      <span className="overline-label mb-1 block text-[0.6rem]">{label}</span>
      <input required type={type} value={value} onChange={onChange} data-testid={testid}
        className="w-full border border-white/15 bg-black px-4 py-3 text-sm text-cream outline-none focus:border-gold" />
    </label>
  );
}
